import OverviewView from "./views/overview/OverviewView";
import JourneyView from "./views/journey/JourneyView";
import DataFlowView from "./views/dataFlow/DataFlowView";
import ProfilesView from "./views/profiles/ProfilesView";
import BehavioralView from "./views/behavioral/BehavioralView";
import { getTenantType } from "./tenant/tenant";

import DataQualityView from "./views/pharma/dataQuality/DataQualityView";
import CohortOverviewView from "./views/pharma/cohort/CohortOverviewView";
import CohortJourneyView from "./views/pharma/cohort/CohortJourneyView";
import SubgroupsOverviewView from "./views/pharma/subgroups/SubgroupsOverviewView";
import SubgroupsCharacterizationView from "./views/pharma/subgroups/SubgroupsCharacterizationView";
import SubgroupsQolView from "./views/pharma/subgroups/SubgroupsQolView";
import SubgroupsAdherenceView from "./views/pharma/subgroups/SubgroupsAdherenceView";

/**
 * Vistas del dashboard, declaradas en un unico sitio: navegacion (agrupada) y
 * rutas se generan de aqui. Grupos: radiografia · seguimiento · negocio.
 *
 * Cada entrada usa `Component` (compartido por clinica y farma). Para que una
 * pantalla DIFIERA por tipo (grafo/layout/lo que sea) sin afectar a la otra,
 * se crea un componente propio y se registra en `byType`:
 *
 *   import OverviewFarma from "./views/overview/OverviewView.farma";
 *   { key: "overview", ..., Component: OverviewView, byType: { farma: OverviewFarma } }
 *
 * El router (App.jsx · TenantView) elige `byType[tipo]` si existe, si no `Component`.
 * Mientras no haya `byType`, ambos tipos ven la misma pantalla (identicas).
 */
export const dashboardViews = [
    // "Calidad del dato" en su propia subseccion, primera del todo — igual
    // patron que "pharmaDataQuality" en el dashboard de farma.
    { key: "dataFlow", path: "/flujo-datos", hu: "HU-3", group: "calidadDato", Component: DataFlowView },
    { key: "overview", path: "/", hu: "HU-1", group: "radiografia", Component: OverviewView },
    { key: "journey", path: "/journey", hu: "HU-2", group: "radiografia", Component: JourneyView },
    { key: "profiles", path: "/perfiles", hu: "HU-4", group: "radiografia", Component: ProfilesView },
    { key: "behavioral", path: "/conductual", hu: "HU-5", group: "radiografia", Component: BehavioralView },
    // "impact" (HU-7, Impacto con/sin app) oculto a peticion del negocio: son
    // afirmaciones comerciales sin dato propio que las respalde, no alineadas
    // con el proposito de la demo (mostrar el tipo de analisis, no vender
    // resultados no demostrados). Componente y ruta se dejan intactos: basta
    // con volver a añadir esta entrada para reactivarlo.
];

// Orden y etiquetas de los grupos de navegacion (como en el HTML).
export const navGroups = ["calidadDato", "radiografia", "seguimiento"];

/**
 * Dashboard pharma: IA propia (5 modulos, ver GUIA-DE-TRABAJO.md §6.5), no un
 * override de las vistas de clinica. `key`/`group` van prefijados con
 * "pharma" para que las plantillas i18n existentes de Sidebar/MobileTopNav
 * (`nav.${key}`, `sidebar.groups.${group}`) resuelvan contra claves propias
 * de `farma.json` sin tocar esos componentes. El primer modulo usa
 * `path: "/"` (landing de farma tras login, igual que Overview en clinica).
 */
export const pharmaDashboardViews = [
    { key: "pharmaDataQuality", path: "/", group: "pharmaDataQuality", Component: DataQualityView },
    { key: "pharmaCohortOverview", path: "/cohorte", group: "pharmaCohort", Component: CohortOverviewView },
    { key: "pharmaCohortJourney", path: "/cohorte/recorrido", group: "pharmaCohort", Component: CohortJourneyView },
    { key: "pharmaSubgroupsOverview", path: "/subgrupos", group: "pharmaSubgroups", Component: SubgroupsOverviewView },
    { key: "pharmaSubgroupsCharacterization", path: "/subgrupos/caracterizacion", group: "pharmaSubgroups", Component: SubgroupsCharacterizationView },
    { key: "pharmaSubgroupsQol", path: "/subgrupos/qol", group: "pharmaSubgroups", Component: SubgroupsQolView },
    { key: "pharmaSubgroupsAdherence", path: "/subgrupos/adherencia", group: "pharmaSubgroups", Component: SubgroupsAdherenceView },
];

export const pharmaNavGroups = ["pharmaDataQuality", "pharmaCohort", "pharmaSubgroups"];

/**
 * Resuelve que par vistas/grupos usar segun el tipo de tenant activo.
 * App.jsx, Sidebar.jsx, MobileTopNav.jsx y ViewContainer.jsx llaman a esto
 * en vez de importar `dashboardViews`/`navGroups` directamente, para que
 * farma pueda tener una navegacion/rutas propias sin tocar clinica.
 */
export function getDashboardConfig(type = getTenantType()) {
    return type === "farma"
        ? { views: pharmaDashboardViews, groups: pharmaNavGroups }
        : { views: dashboardViews, groups: navGroups };
}
